<template>
  <v-row align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-card flat class="ma-0 pa-0 overflow-y-auto" color="transparent" :style="contentsHeight + ' overflow-x: hidden;'">
        <v-row v-for="item in group" align="center" class="ma-0 pa-0" :key="item + 'header'">
          <v-col cols="12" class="pa-0 b-B-TITLE">
            <v-row align="baseline" class="ma-0 pa-0">
              <v-col cols="4" class="pa-0">
                <v-card-title class="pb-0">{{ getName(item) }}</v-card-title>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-card-text :key="item">
              <v-row align="center" class="ma-0 pa-0">
                <v-col cols="2" class="pa-0">
                  <v-toolbar flat height="21" color="transparent" >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-col>
                <v-col cols="10" class="pa-0">
                  <v-row align="center" class="ma-0 pa-0">
                      <v-col class="pa-0" align="center" v-for="i in 13" :key="i">
                        <v-sheet
                          :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                          dark
                          height="21"
                          :key="i"
                          tile
                          :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                        >
                          <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">{{ getMonth(i, "total") }}</span>
                        </v-sheet>
                      </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <template v-for="(metric, index) in headers">
                <v-row v-if="data && metric.roles[getPrivilege(data)]" align="center" class="ma-0 pa-0 text-right" :key="index">
                  <v-col cols="2" class="pa-0">
                    <v-sheet color="transparent" tile :class="(headers.length - 1) == index && compare === 'N/A' ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                      <template v-if="metric.type != 'header'">
                        <span class="pl-4">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                      </template>
                      <template v-else>
                        <v-toolbar flat :color="pColor(item)" height="20">
                          <span class="white--text select-none">{{ metric.name }}</span>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>
                    </v-sheet>
                    <template v-if="compare != 'N/A'">
                      <v-sheet :color="metric.type == 'header' ? pColor(item) : 'transparent'" tile :class="(headers.length - 1) == index ? 'b-L-GREY b-B-GREY' : 'b-L-GREY'" height="21">
                      </v-sheet>
                    </template>
                  </v-col>
                  <v-col cols="10" class="pa-0">
                    <v-row align="center" class="ma-0 pa-0">
                      <v-col class="pa-0" v-for="i in 13" :key="i">
                        <v-sheet
                          :class="getBackgroundColor(mm, i, index)"
                          :color="checkValue(item, i, index, metric)"
                          height="21"
                          :key="i"
                          tile
                        >
                          <template v-if="i != 13">
                            <span
                              style="text-align: right; width: 100%;"
                              :class="metric.type == 'header' && year == getFY() && mm == i ? 'white--text pr-1 clickable' : 'pr-1 clickable'"
                              @click.stop="onValueSelect(item, i, 0, metric)"
                            >
                              {{ getValue(item, i, index, 0, metric) }}
                            </span>
                          </template>
                          <template v-else>
                            <span
                              style="text-align: right; width: 100%;"
                              class="pr-1 font-weight-bold select-none"
                            >
                              {{ getTotalValue(item, index, metric, 0) }}
                            </span>
                          </template>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <template v-if="compare != 'N/A'">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col class="pa-0" v-for="i in 13" :key="i">
                          <v-sheet
                            :class="getBackgroundColor(mm, i, index)"
                            :color="compare == '目標' ? sColor : '#bbbbbb30'"
                            height="21"
                            :key="i"
                            tile
                          >
                            <span
                              v-if="i != 13"
                              style="text-align: right; width: 100%;"
                              class="pr-1 select-none"
                            >
                              {{ getValue(item, i, index, 1, metric) }}
                            </span>
                            <span v-else
                              style="text-align: right; width: 100%;"
                              class="pr-1 font-weight-bold select-none"
                            >
                              {{ getTotalValue(item, index, metric, 1) }}
                            </span>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-card-text>
              <v-row align="center" class="ma-0 pa-0">
                <v-col cols="2" class="pa-0">
                  <v-toolbar flat height="21" color="transparent" >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-col>
                <v-col cols="10" class="pa-0">
                  <v-row align="center" class="ma-0 pa-0">
                      <v-col class="pa-0" align="center" v-for="i in 13" :key="i">
                        <v-sheet
                          :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                          dark
                          height="21"
                          :key="i"
                          tile
                          :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                        >
                          <span :class="year == getFY() && mm == i ? 'white--text select-none' : 'secondary--text select-none'">{{ getMonth(i) }}</span>
                        </v-sheet>
                      </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <template v-for="(metric, index) in kpis">
                <v-row v-if="data && metric.roles[getPrivilege(data)]" align="center" class="ma-0 pa-0 text-right" :key="index">
                  <v-col cols="2" class="pa-0">
                    <v-sheet color="transparent" tile :class="(headers.length - 1) == index && compare === 'N/A' ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                      <template v-if="metric.type != 'header'">
                        <span class="pl-4">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                      </template>
                      <template v-else>
                        <v-toolbar flat :color="pColor(item)" height="20">
                          <span class="white--text select-none">{{ metric.name }}</span>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>
                    </v-sheet>
                    <template v-if="compare != 'N/A'">
                      <v-sheet :color="metric.type == 'header' ? pColor(item) : 'transparent'" tile :class="(headers.length - 1) == index ? 'b-L-GREY b-B-GREY' : 'b-L-GREY'" height="21">
                      </v-sheet>
                    </template>
                  </v-col>
                  <v-col cols="10" class="pa-0">
                    <v-row align="center" class="ma-0 pa-0">
                      <v-col class="pa-0" v-for="i in 13" :key="i">
                        <v-sheet
                          :class="getBackgroundColor(mm, i, index)"
                          :color="checkValue(item, i, index, metric)"
                          height="21"
                          :key="i"
                          tile
                        >
                          <template v-if="i != 13">
                            <span
                              style="text-align: right; width: 100%;"
                              :class="metric.type == 'header' && year == getFY() && mm == i ? 'white--text pr-1 clickable' : 'pr-1 clickable'"
                              @click.stop="onValueSelect(item, i, 0, metric)"
                            >
                              {{ getKPIValue(item, i, index, 0, metric) + '%' }}
                            </span>
                          </template>
                          <template v-else>
                            <span
                              style="text-align: right; width: 100%;"
                              class="pr-1 font-weight-bold select-none"
                            >
                              {{ getKPITotalValue(item, index, metric, 0) + '%' }}
                            </span>
                          </template>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <template v-if="compare != 'N/A'">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col class="pa-0" v-for="i in 13" :key="i">
                          <v-sheet
                            :class="getBackgroundColor(mm, i, index)"
                            :color="compare == '目標' ? sColor : '#bbbbbb30'"
                            height="21"
                            :key="i"
                            tile
                          >
                            <span
                              v-if="i != 13"
                              style="text-align: right; width: 100%;"
                              class="pr-1 select-none"
                            >
                              {{ getKPIValue(item, i, index, 1, metric) + '%' }}
                            </span>
                            <span v-else
                              style="text-align: right; width: 100%;"
                              class="pr-1 font-weight-bold select-none"
                            >
                              {{ getKPITotalValue(item, index, metric, 1) + '%' }}
                            </span>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <v-dialog v-model="listDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-list-dialog
          v-if="listDialog"
          @dismissed="onDismissed"
          :tempGroups="tempGroups"
          :selected="selected"
          :type="type"
        >
        </app-list-dialog>
      </v-dialog>
    </div>

  </v-row>
</template>
<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
export default {
  props: [ 'year', 'group', 'tempGroups', 'compare', 'indicator', 'status', 'plans', 'diffs', 'kpidata', 'diffkpidata', 'sColor' ],
  data () {
    return {
      mm: 0,
      loading: false,
      listDialog: false,
      type: 1,
      items: {},
      item: null,
      line0: [],
      line1: [],
      headers: [
        { key: 301, name: '問合せ', group: 'X', type: 'header', sufix: '件', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 302, name: '保護者面談', group: 'X', type: 'header', sufix: '件', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 303, name: '体験授業', group: 'X', type: 'header', sufix: '件', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 304, name: '提案', group: 'X', type: 'header', sufix: '件', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 305, name: '入塾', group: 'X', type: 'header', sufix: '件', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      kpis: [
        { key: 1, name: '面談アポ率', type: 'header', tips: '保護者面談 ÷ 問合せ', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 2, name: '体験アポ率', type: 'header', tips: '体験授業 ÷ 保護者面談', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { key: 4, name: '入塾率', type: 'header', tips: '入塾 ÷ 問合せ', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      windowSize: 'shared/windowSize',
      extension: 'shared/extension'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  created () {
    if (this.extension === 1) {
      this.headers[4].name = '入会'
      this.kpis[2].name = '入会率'
    }
    moment.tz.setDefault('Asia/Tokyo')
    var mm = moment().month()
    this.mm = mm > 2 ? mm - 2 : mm + 10
  },
  methods: {
    pColor (group) {
      var color = 'primary'
      if (group !== '*') {
        var index = this.groups.findIndex(g => g.key === group)
        if (index !== -1) {
          if (typeof this.groups[index].color !== 'undefined') {
            return this.groups[index].color
          }
        }
      }
      return color
    },
    getBackgroundColor (mm, i, index) {
      var color = (i === 13 ? 'd-flex b-L-GREY b-R-GREY b-T-GREY' : 'd-flex b-L-GREY b-T-GREY')
      if ((this.headers.length - 1) === index && this.compare === 'N/A') {
        color += ' b-B-GREY'
      }
      return color
    },
    checkValue (item, i, index, metric) {
      if (metric.type === 'header' || metric.type === 'none') {
        return this.year === this.getFY() && this.mm === i ? this.pColor(item) : this.getWeekColor(1)
      }
      if (item === '*') {
        return 'transparent'
      }
      if (this.fn === 'plan' && this.items[item] && i !== 13 && this.items[item][i - 1][index].modify) {
        return 'pink lighten-5'
      }
      return 'transparent'
    },
    getTotalValue (item, index, metric, type) {
      var a = 0
      var ac = 0
      var p = 0
      var d = 0
      if (!this.status[item]) {
        return 0
      }
      for (var x = 0; x < 12; x++) {
        if (typeof this.status[item][x][index + 1] !== 'undefined') {
          var v = this.status[item][x][index + 1].length
          if (this.indicator === '%') {
            var div = 0
            if (this.compare === '目標') {
              div = this.plans[item][x][index + 301].value
            } else {
              div = this.diffs[item][x][metric.key - 300].length
            }
            var pt = Math.round(this.status[item][x][index + 1].length / div * 10) / 10
            v = isNaN(pt) || pt === Infinity ? 0 : Math.round(pt * 100)
          }
          if (v !== 0) {
            ac += 1
          }
          a += v
        }
      }
      if (this.compare === '目標') {
        for (x = 0; x < 12; x++) {
          p += this.plans[item][x][metric.key].value
        }
      }
      if (this.compare !== 'N/A' && this.compare !== '目標') {
        for (x = 0; x < 12; x++) {
          d += this.diffs[item][x][metric.key - 300].length
        }
      }
      if (type === 0) {
        if (this.compare !== 'N/A' && this.indicator === '%') {
          if (this.compare === '目標') {
            var r = Math.round((a / ac))
            return isNaN(r) || r === Infinity ? '0%' : r + '%'
          } else {
            r = Math.round((a / ac))
            return isNaN(r) || r === Infinity ? '0%' : r + '%'
          }
        } else {
          return a
        }
      } else {
        if (this.compare === '目標') {
          return p
        } else {
          return d
        }
      }
    },
    getKPITotalValue (item, index, metric, type) {
      var a = 0
      var ac = 0
      var p = 0
      var pc = 0
      var d = 0
      var dc = 0
      if (!this.status[item]) {
        return 0
      }
      for (var x = 0; x < 12; x++) {
        if (typeof this.kpidata[item][x][6] !== 'undefined') {
          ac += this.kpidata[item][x][6]
        }
      }
      for (x = 0; x < 12; x++) {
        if (typeof this.kpidata[item][x][3 + index] !== 'undefined') {
          a += this.kpidata[item][x][3 + index]
        }
      }
      if (this.compare === '目標') {
        for (x = 0; x < 12; x++) {
          pc += this.plans[item][x][301].value
          switch (index) {
            case 0:
              p += this.plans[item][x][302].value
              break
            case 1:
              p += this.plans[item][x][303].value
              break
            case 2:
              p += this.plans[item][x][305].value
              break
          }
        }
      }
      if (this.compare !== 'N/A' && this.compare !== '目標') {
        for (x = 0; x < 12; x++) {
          dc += this.diffs[item][x][1].length
          switch (index) {
            case 0:
              d += this.diffs[item][x][2].length
              break
            case 1:
              d += this.diffs[item][x][3].length
              break
            case 2:
              d += this.diffs[item][x][5].length
              break
          }
        }
      }
      if (type === 0) {
        var r = Math.round((a / ac) * 100)
        return isNaN(r) || r === Infinity ? 0 : r
      } else {
        if (this.compare === '目標') {
          r = Math.round((p / pc) * 100)
          return isNaN(r) || r === Infinity ? 0 : r
        } else {
          r = Math.round((d / dc) * 100)
          return isNaN(r) || r === Infinity ? 0 : r
        }
      }
    },
    getValue (item, month, index, type, metric) {
      var value = 0
      if (!this.status[item]) {
        return value
      }
      if (type === 0) {
        value = this.status[item][month - 1][index + 1].length
        if (this.compare !== 'N/A') {
          var div = 0
          if (this.compare === '目標') {
            div = this.plans[item][month - 1][index + 301].value
          } else {
            div = this.diffs[item][month - 1][metric.key - 300].length
          }
          if (this.indicator === '%') {
            var p = Math.floor(this.status[item][month - 1][index + 1].length / div * 10) / 10
            value = isNaN(p) || p === Infinity ? 0 : Math.round(p * 100)
          }
        }
      } else {
        if (this.compare === '目標') {
          value = this.plans[item][month - 1][index + 301].value
        } else {
          value = this.diffs[item][month - 1][metric.key - 300].length
        }
      }
      if (this.compare !== 'N/A' && this.indicator === '%' && type === 0) {
        value += '%'
      }
      return value
    },
    getKPIValue (item, month, index, type, metric) {
      var value = 0
      if (!this.status[item]) {
        return value
      }
      if (type === 0) {
        return this.kpidata[item][month - 1][index]
      } else {
        if (this.compare === '目標') {
          var b = this.plans[item][month - 1][301].value
          if (index === 0) {
            var a = this.plans[item][month - 1][302].value
          } else if (index === 1) {
            a = this.plans[item][month - 1][303].value
          } else {
            a = this.plans[item][month - 1][305].value
          }
          var r = Math.round(a / b * 100)
          return (isNaN(r) || r === Infinity ? 0 : r)
        } else {
          return this.diffkpidata[item][month - 1][index]
        }
      }
    },
    getName (item) {
      if (item === '*') {
        return '全校'
      }
      var index = this.groups.findIndex(group => group.key === item)
      if (index !== -1) {
        return this.groups[index].name
      }
      return ''
    },
    onDismissed: function (result) {
      this.dialog = false
      this.listDialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onUpdate () {
    },
    onValueSelect (item, month, type, metric) {
      var index = this.headers.findIndex(head => head.key === metric.key)
      if (month === 13) {
        if (this.totalsStatus[item][index].length !== 0) {
          this.selected = this.totalsStatus[item][index]
          this.listDialog = true
        }
      } else if (this.status[item][month - 1][index + 1].length !== 0) {
        this.selected = this.status[item][month - 1][index + 1]
        this.listDialog = true
      }
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}
span.clickable {
  cursor: pointer !important;
}
.select-none {
  user-select: none;
}
.b-B-TITLE {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-R-GREY {
  border-right: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid #80808080 !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
